
import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    projects: {
      add: 'Add Project',
      delete: 'Delete Project'
    }
  },
  de: {
	view: {
		planner: 'Planer',
		projects: 'Projekte',
		bookings: 'Buchungen',
		resources: 'Resourcen',
		settings:  'Einstellungen',
		loginerror: "Login Fehler, bitte User/Kennwort überprüfen",
		loginerrornetwork: "Login Fehler, fehler im Netzwerk",
		item: {
			Projekte: 'Projekt',
			Buchungen: 'Buchung',
			Resourcen: 'Resource',
			Einstellungen: 'Einstellung',
		}
	},
    projects: {
      add: 'Projekt hinzufügen',
      delete: 'Projekt löschen'
    }
  }
};

const i18n = createI18n({
  legacy: false,
  locale: 'de', // or 'de'
  fallbackLocale: 'en',
  messages
});

export default i18n;
